<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="3">
          <ElInput v-model="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i
          ></ElInput>
        </ElFormItem>
        <ElFormItem label="创建人">
          <auto-complete :data="agentData" width="100" v-model="agentId" placeholder="全部" @on-select="handleAgent"></auto-complete>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="open">新建规则</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { isArray, trim } from '@/common/js/utils'
import { setLocal, getLocal } from '@/common/js/api'
import { getSysMember } from '@/api/common.model'
import AutoComplete from '@/components/autocomplete/autocomplete'

export default {
  name: 'iOSFilter',
  components: { AutoComplete },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      const params = {
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: this.keyword === '' ? undefined : trim(this.keyword)
      }
      this.$emit('on-change', params)
    },
    search() {
      const params = {
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: this.keyword === '' ? undefined : trim(this.keyword)
      }
      this.$emit('on-search', params)
    },
    proloadData() {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal('list-iOS')
      getSysMember()
        .then((data) => {
          if (isArray(data)) {
            this.agentData = data
            if (storage && isArray(storage[account])) this.agentId = Number(storage[account])
            else this.agentId = Number(account) || ''
          }
          // 初始化
          this.sendEvent()
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    handleAgent(meta) {
      let opId
      this.agentId = meta.id
      if (meta && meta.id) opId = meta.id
      else opId = -1
      this.setOperatorStorage('list-iOS', opId)
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    open() {
      this.$router.push({ name: 'iosmonitoradd' })
    }
  },
  watch: {
    type(nVal) {
      this.sendEvent()
    },
    agentId(nVal) {
      this.sendEvent()
    }
  },
  data() {
    return {
      keyword: '',
      agentId: '',
      agentData: []
    }
  },
  created() {
    this.proloadData()
  }
}
</script>
